export default {
    styleOverrides: {
        filledSuccess: () => {
            return {
                color: 'white'
            }
        },
    }
}
